export const SET_BRANDS = "SET_BRANDS";
export const SET_BRANDS_ERROR = "SET_BRANDS_ERROR";
export const SET_BRANDS_LOADING = "SET_BRANDS_LOADING";
export const SET_CREATED_BRAND = "SET_CREATED_BRAND";
export const SET_UPDATED_BRAND = "SET_UPDATED_BRAND";
export const REMOVE_DELETED_BRAND = "REMOVE_DELETED_BRAND";
export const SET_BRANDS_FETCHING = "SET_BRANDS_FETCHING";
